import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { TYPES } from '@pixi/constants';
var Attribute = /*#__PURE__*/function () {
  function Attribute(buffer) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var normalized = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TYPES.FLOAT;
    var stride = arguments.length > 4 ? arguments[4] : undefined;
    var start = arguments.length > 5 ? arguments[5] : undefined;
    var instance = arguments.length > 6 ? arguments[6] : undefined;
    _classCallCheck(this, Attribute);
    this.buffer = buffer;
    this.size = size;
    this.normalized = normalized;
    this.type = type;
    this.stride = stride;
    this.start = start;
    this.instance = instance;
  }
  _createClass(Attribute, [{
    key: "destroy",
    value: function destroy() {
      this.buffer = null;
    }
  }], [{
    key: "from",
    value: function from(buffer, size, normalized, type, stride) {
      return new Attribute(buffer, size, normalized, type, stride);
    }
  }]);
  return Attribute;
}();
export { Attribute };